import { CircadiaEngineProviderFactory } from "./hexagon/adapters/driven/providers/circadiaEngineProvider";
import { mockFieldSetupEngine } from "./dev/mockCircadiaEngine";

/** Native shell injects `window.circadiaapp`; some hosts also set `window.circadia`. */
const circadiaNative =
  typeof window !== "undefined"
    ? ((window as typeof window & { circadia?: ICircadiaEngine }).circadia ??
        (window as typeof window & { circadiaapp?: ICircadiaEngine })
          .circadiaapp)
    : undefined;

/** True when the NativeAuth / Circadia bridge is present — real device / Capacitor shell. */
const hasNativeBridge = Boolean(circadiaNative);

/** Full provider (native or browser stubs) — unchanged factory output. */
export const circadiaEngineProvider = CircadiaEngineProviderFactory({
  circadia: circadiaNative,
});

/**
 * Field Setup entrypoint: in browser DEV without a native bridge, merge mock behaviors
 * so login → dashboard → setup flow is testable. Native / production web use provider only.
 */
export const circadiaEngine =
  !hasNativeBridge && import.meta.env.DEV
    ? Object.assign({}, circadiaEngineProvider, mockFieldSetupEngine)
    : circadiaEngineProvider;

if (!hasNativeBridge && import.meta.env.DEV) {
  console.info(
    "[FieldSetup] Using mock engine — browser dev mode (no window.circadia / circadiaapp)"
  );
}

if (!hasNativeBridge && !import.meta.env.DEV) {
  console.warn(
    "[FieldSetup] No native bridge in production web build — using provider stubs only"
  );
}
